import styled from 'styled-components';
import { Tooltip } from 'ui/tooltip';
import { displayDate, DATE_FORMAT_FULL_WITH_TIME, getFromNow } from 'utils/date';
import { BaseCell } from './BaseCell';

const StyledTrigger = styled.span`
  border-bottom: 1px dashed #717171;
`;

// type DateCellProps = {
//   value: number | string,
// };

export const createDateCell =
  (useBaseCell /*: boolean */) =>
  ({ value } /*: DateCellProps */) => {
    const date = getFromNow(value);
    const formattedTooltipValue = displayDate(value, DATE_FORMAT_FULL_WITH_TIME);

    const Cell = (
      <Tooltip tooltipContent={formattedTooltipValue}>
        <StyledTrigger data-test="date-cell-trigger">{date}</StyledTrigger>
      </Tooltip>
    );

    if (useBaseCell) {
      return <BaseCell data-test="date-cell-base-cell">{Cell}</BaseCell>;
    }

    return Cell;
  };

export const DateCell = createDateCell(true);
export const CleanDateCell = createDateCell(false);
